import moment from "moment"
import React from "react"
import { developmentTaskStatus, ticketStatus } from "utils/common-options";
export const TodaysTaskColumns = () => [
    {
        Header: "Task ID",
        accessor: "id",
        title: "ID",
        isInfoIcon: false,
        className: "project_id text-center",
    },
    {
        Header: "Project Name",
        title: "Project Name",
        accessor: "project_name",
        isInfoIcon: false,
        className: "col-2",
    },
    {
        Header: "Task Name",
        title: "Task Name",
        accessor: "title",
        isInfoIcon: false,
        className: "col-5",
        Cell: (cellProps) => {
            const data = cellProps?.row?.original;
            const icons = data?.task_type == "project_task" ? 'fas fa-clipboard-list text-success' : data?.task_type == "code_review" ? 'fas fa-file-code text-primary' : data?.task_type == "support_ticket" ? 'fas fa-ticket-alt text-info' : ''
            return <div><i className={`${icons} me-2 font-size-16`}></i>{data?.title}</div>;
        },
    },
    {
        Header: "Hours",
        accessor: "estimation_days",
        isInfoIcon: false,
        className: "col-1 text-center",
        Cell: (cellProps) => {
            return (
                <div className="text-center">
                    {cellProps?.row?.original?.estimation_days || "-"}
                </div>
            );
        },
    },
    {
        Header: "Status",
        accessor: "status",
        isInfoIcon: false,
        className: "col-1",
        Cell: (cellProps) => {
            const data = cellProps?.row?.original;
            const status = data?.task_type == "project_task" ? developmentTaskStatus.find(
                (obj) => obj.value === cellProps.row.original.status
            )?.label : data?.task_type == "code_review" ? data?.status : data?.task_type == "support_ticket" ? ticketStatus.find(
                (obj) => obj.value === cellProps.row.original.status
            )?.label : ''
            return (
                <div className="custom-select-wrapper">
                    {status || "-"}
                </div>
            );
        },
    },
    {
        Header: "Today's Time",
        accessor: "total_time_spent",
        isInfoIcon: false,
        className: "col-auto text-center total_time_spent",
        Cell: (cellProps) => {
            return (
                <div className="text-center">
                    {cellProps?.row?.original?.total_time_spent || "-"}
                </div>
            );
        },
    },
    {
        Header: "Overall Time",
        accessor: "total_time_spent_overall",
        isInfoIcon: false,
        className: "text-center total_time_spent",
        Cell: (cellProps) => {
            return (
                <div className="text-center">
                    {cellProps?.row?.original?.total_time_spent_overall || "-"}
                </div>
            );
        },
    },
];